// @flow

export default class CookieUtils {
  static setCookie = (cookie: string, maxAge: number) => {
    document.cookie = `${cookie};max-age=${maxAge};path=/;secure;`;
  };

  static getCookie = (cookie: string) => {
    const matches = document.cookie.split(';')
      .map(s => s.trim())
      .filter(c => c.split('=')[0] === cookie);
    if (matches.length > 0) {
      return matches[0].split('=')[1];
    }
    return '';
  };
}
